import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-red",
  "use": "icon-down-red-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol viewBox=\"0 0 14 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down-red\">\n<path id=\"icon-down-red_Polygon 5\" d=\"M6.13398 10.5C6.51888 11.1667 7.48112 11.1667 7.86603 10.5L13.0622 1.5C13.4471 0.833333 12.966 0 12.1962 0H1.80385C1.03405 0 0.552922 0.833333 0.937822 1.5L6.13398 10.5Z\" fill=\"#FF0606\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol